import useCheckDevice from "@repo/shopify/hooks/useCheckDevice";
import React from "react";

import Button from "@atoms/Button";
import Dim from "@atoms/Dim";
import Icon from "@atoms/Icon";

import { useLayoutStore } from "@store/layout";

export default function Modal() {
  const { isPC } = useCheckDevice();
  const { modal, openModal, isLoading } = useLayoutStore();

  const hasCTA = Boolean(modal?.cancel) || Boolean(modal?.confirm);

  return (
    <div className="relative dark:text-white">
      <section className="center pc:w-1/3 pc:p-5 pc:gap-5 fixed z-80 flex max-h-[80%] w-[calc((100%-2rem))] flex-col gap-4 rounded-sm bg-white p-4 shadow lg:w-1/4 dark:bg-black dark:shadow-white">
        <div className="flex flex-row justify-between">
          <span className="capitalize">{modal?.title || ""}</span>
          <Button
            as="text"
            onClick={() => {
              modal?.onClickClose?.();
              openModal(null);
            }}
          >
            {isPC ? "Close" : <Icon className="size-3.5" name="Close" />}
          </Button>
        </div>
        <div className="scrollbar-hide overflow-y-scroll">{modal?.content || ""}</div>

        {hasCTA ? (
          <div className="flex flex-row gap-1">
            {Boolean(modal?.cancel) && (
              <Button
                as="square"
                onClick={() => {
                  openModal(null);
                  modal?.cancel?.onClick?.();
                }}
                variant={modal?.confirm ? "secondary" : "primary"}
              >
                {modal?.cancel?.label}
              </Button>
            )}
            {Boolean(modal?.confirm) && (
              <Button
                as="square"
                loading={isLoading}
                onClick={() => {
                  modal?.confirm?.onClick?.();
                }}
              >
                {modal?.confirm?.label}
              </Button>
            )}
          </div>
        ) : (
          <>
            {!modal?.isHideCancelButton ? (
              <Button
                as="square"
                onClick={() => {
                  openModal(null);
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            ) : null}
          </>
        )}
      </section>

      <Dim
        onClick={(e) => {
          e.stopPropagation();
          // modal?.cancel?.onClick?.();
          modal?.onClickClose?.();
          openModal(null);
        }}
      />
    </div>
  );
}
